import { ChangeDetectionStrategy, Component, inject, Injector, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  DIALOG_DATA,
  DialogRef,
  IconModule,
  RouteFiltersService,
  SelectComponent,
  SimpleInputModule,
  SpinnerDirective,
  WithAllOptionPipe,
} from '@hglobal/common';
import { AvatarModule, CoursesReportDialogData, UserStatusModule } from '@pt/components';
import { DictionariesService } from '@pt/services';

import {
  COURSES_REPORT_API, CoursesReportApiMock, CoursesReportApiService, MyWardsCoursesReportApiService,
} from './api';
import { getCoursesReportApi } from './course-report-api-service.factory';
import { CoursesReportStore } from './courses-report.store';
import { CoursesReportFilters } from './models';

@Component({
  selector: 'pt-courses-report',
  imports: [
    SpinnerDirective,
    ReactiveFormsModule,
    SelectComponent,
    SimpleInputModule,
    TranslateModule,
    WithAllOptionPipe,
    MatTableModule,
    MatPaginator,
    ButtonModule,
    IconModule,
    AvatarModule,
    UserStatusModule,
  ],
  templateUrl: './courses-report.component.html',
  styleUrl: './courses-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    CoursesReportApiMock,
    CoursesReportApiService,
    MyWardsCoursesReportApiService,
    {
      provide: COURSES_REPORT_API,
      useFactory: getCoursesReportApi,
      deps: [Router],
    },
    CoursesReportStore,
    RouteFiltersService,
  ],
})
export class CoursesReportComponent implements OnInit {
  readonly #store = inject(CoursesReportStore);
  readonly #data = inject<CoursesReportDialogData>(DIALOG_DATA);
  readonly #dialogRef = inject(DialogRef);
  readonly #dictionariesService = inject(DictionariesService);
  readonly #routeFiltersService = inject(RouteFiltersService<CoursesReportFilters>);

  readonly tableData = this.#store.memberCourses;
  readonly isLoading = this.#store.isLoading;
  readonly itemsCount = this.#store.itemsCount;
  readonly userInfo = this.#store.userInfo;

  readonly courseTypes = this.#dictionariesService.courseTypes;
  readonly statuses = this.#dictionariesService.usersCourseStatuses;
  readonly displayedColumns = ['id', 'name', 'type', 'status'];

  readonly filtersForm = this.#routeFiltersService.initialize({
    filtersState: this.#store.filters,
    updateFilters: filters => this.#store.updateFilters(filters),
  });

  ngOnInit(): void {
    this.#store.getUserInfo(this.#data.userId);
  }

  close(): void {
    this.#dialogRef.close();
  }

  onPageChange(event: PageEvent): void {
    this.#routeFiltersService.updateMatPageControls(event);
  }
}
